class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.body = document.querySelector('body');
    this.notificationWrapper = document.querySelector('.cart-notification-wrapper');
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.cartIcon = document.querySelector('.header__icon--cart');
    this.checkoutButton = document.querySelector('.cart-notification-checkout-button');
    this.cartNotificationHeader = document.querySelector('.cart-notification__header');
    
    // Define threshold amounts for each region
    const thresholdAmounts = window.thresholdAmounts;


    const userCountryCode = window.UserCountryCode || 'ROW';

    // Function to determine user location
    function getUserLocation() {
      // console.log('userCountry:', userCountryCode);
      const userCountry = userCountryCode || 'ROW';
      switch (userCountry) {
        case 'GB':
        case 'GG':
        case 'IM':
        case 'JE':
          return 'UK';
        case 'US':
          return 'US';
        case 'AU':
          return 'AUS';
          case 'FR':
          case 'DE':
          case 'IT':
          case 'ES':
          case 'NL':
          case 'BE':
          case 'AT':
          case 'IE':
          case 'PT':
          case 'GR':
          case 'FI':
          case 'SE':
          case 'DK':
          case 'PL':
          case 'CZ':
          case 'HU':
          case 'RO':
          case 'BG':
          case 'HR':
          case 'SI':
          case 'SK':
          case 'EE':
          case 'LV':
          case 'LT':
          case 'CY':
          case 'MT':
          case 'LU':
            return 'EU';
          default:
            return 'ROW';
      }
    }

    // Set the threshold amount based on user location
    const userLocation = getUserLocation();
    this.userCountry = userLocation;
    this.thresholdAmount = thresholdAmounts[userLocation] || thresholdAmounts.ROW; // Default to ROW if location is not found
    // console.log('this is the threshold amount:',this.thresholdAmount);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button.cart-notification__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.querySelector('.cart-background').addEventListener('click', this.close.bind(this));
    this.cartIcon.addEventListener('click', () => this.open());
    document.getElementById('cart__quick_payment-link').addEventListener("click", this.clickQuickPayment);

    // Initial update
    this.updateThresholdHTML(this.getCartTotal());

    // Set up the MutationObserver
    const cartTotalElement = document.querySelector('.totals__subtotal-value');
    if (cartTotalElement) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'subtree') {
            this.updateThresholdHTML(this.getCartTotal());
          }
        });
      });
      observer.observe(cartTotalElement, { childList: true, subtree: true });
    }
  }

  open() {
    this.querySelector('.cart-background').classList.add('active');
    this.notification.classList.add('animate', 'active');
    this.notificationWrapper.classList.add('active');
    this.body.classList.add('cart--open');
   

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    if (window.hasOwnProperty("ga")){
      ga('send', 'pageview', '/cart-flyout');
    }

  }

  close() {
    this.querySelector('.cart-background').classList.remove('active');
    this.notification.classList.remove('active');
    this.notificationWrapper.classList.remove('active');
    this.body.classList.remove('cart--open');
    // Close quick payment options
    let quickPaymentLink = document.getElementById('cart__quick_payment-link');
    let quickPaymentWrapper = document.getElementById('cart__quick_payment-wrapper');
    if (quickPaymentLink && quickPaymentWrapper){
      quickPaymentLink.style.display = "block";
      quickPaymentWrapper.style.display = "none";
    }
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  buildCart(data) {
    // clear cart to avoid duplicate items
    document.querySelector('.cart-notification-product-wrapper .cart-items tbody').innerHTML = '';
    // update subtotal in cart overlay
    document.querySelector('#main-cart-footer .totals__subtotal-value').textContent = Shopify.formatMoney(data.items_subtotal_price).replace(' ','');
    // update cart bubble in header
    document.querySelector('.cart-count-bubble span').textContent = data.item_count;
    document.querySelector('.cart-count-bubble').setAttribute('data-count', data.item_count);

    data.items.forEach((product, i) => {
    document.querySelector('.cart-notification-product-wrapper .cart-items tbody').innerHTML += `
      <tr class="cart-item" id="CartItem-${i + 1}">
        <td class="cart-item__media">
          <a href="${product.url}" class="cart-item__link" aria-hidden="true" tabindex="${i + 1}"> </a>
          <div class="cart-item__image-container gradient global-media-settings">
              <img src="${product.image}" class="cart-item__image" alt="${product.product_title}" loading="lazy" width="150" height="226">
          </div>
        </td>
        <td class="cart-item__details">
          <a href="${product.url}" class="cart-item__name body__copy--bold break">${product.product_title}</a>
          <dl>
              ${product.variant_options[0] != '500000' ? `
              <div class="product-option body__copy--tiny">
                <dd>${product.variant_options[0]}</dd>
              </div>
              ` : ''}
              <div class="product-option body__copy--tiny">
                <dd data-variant-option="${product.variant_options[1]}">${product.variant_options[1]}</dd>
              </div>
              <div class="product-option body__copy--tiny">
                <dd data-variant-option="${product.variant_options[2]}">${product.variant_options[2]}</dd>
              </div>                            
          </dl>
          <p class="product-option"></p>
          <div class="product-option product-option--price">
            ${Shopify.formatMoney((product.price))}
          </div>
          <ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul>
        </td>
        <td class="cart-item__totals right">
          <div class="loading-overlay hidden">
              <div class="loading-overlay__spinner">
                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
          </div>
          <div class="cart-item__price-wrapper body__copy--bold"><span class="price price--end">
            ${Shopify.formatMoney((product.price * product.quantity)).replace(' ','')}
              </span>
          </div>
        </td>
        <td class="cart-item__quantity">
          <div class="cart-item__quantity-wrapper">
              <label class="visually-hidden" for="Quantity-1">
              Quantity
              </label>
              <quantity-input class="quantity">
                <button class="quantity__button no-js-hidden" name="minus" type="button">
                    <span class="visually-hidden">Decrease quantity for ${product.product_title}</span>
                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-minus" viewBox="0 0 12 2">
                      <path d="M0 0h12v2H0V0Z" fill="#000"></path>
                    </svg>
                </button>
                <input class="quantity__input" type="number" name="updates[]" value="${product.quantity}" min="0" aria-label="Quantity for ${product.product_title}" id="Quantity-${i + 1}" data-index="${i + 1}">
                <button class="quantity__button no-js-hidden" name="plus" type="button">
                    <span class="visually-hidden">Increase quantity for ${product.product_title}</span>
                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-plus" viewBox="0 0 12 12">
                      <path d="M5 7v5h2V7h5V5H7V0H5v5H0v2h5Z" fill="#000"></path>
                    </svg>
                </button>
              </quantity-input>
              <cart-remove-button id="Remove-${i + 1}" data-index="${i + 1}">
                <a href="${window.routes.cart_change_url}?id=${product.key}&amp;quantity=0" aria-label="Remove ${product.product_title} - ${product.variant_options[0]}">
                Remove
                </a>
              </cart-remove-button>
          </div>
          <div class="cart-item__error" id="Line-item-error-1" role="alert">
              <small class="cart-item__error-text"></small>
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
                <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
                </path>
              </svg>
          </div>
        </td>
      </tr>`;
  });

    // If cart items: enable/disable checkout button
    if (this.checkoutButton) {
      this.checkoutButton.disabled = (data.item_count === 0);
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  clickQuickPayment(event) {
    // Open quick payment options
    let quickPaymentLink = document.getElementById('cart__quick_payment-link');
    let quickPaymentWrapper = document.getElementById('cart__quick_payment-wrapper');
    if (quickPaymentLink && quickPaymentWrapper){
      quickPaymentLink.style.display = "none";
      quickPaymentWrapper.style.display = "block";
    }
  }

  updateThresholdHTML(cartTotal) {
    // Function to get the currency symbol from the cart total element
function getCurrencySymbol() {
  const cartTotalElement = document.querySelector('.totals__subtotal-value');
  if (cartTotalElement) {
    const match = cartTotalElement.textContent.match(/[^\d.-]/);
    return match ? match[0] : '£'; // Default to £ if no symbol is found
  }
  return '£'; // Default to £ if element is not found
}

// Use the extracted currency symbol in the template string
const currencySymbol = getCurrencySymbol();
const thresholdMessage = `${currencySymbol}${(this.thresholdAmount - cartTotal).toFixed(2)}`;

const thresholdElement = document.querySelector('.cv-4-0-delivery-threshold');
const percentage = Math.min((cartTotal / this.thresholdAmount) * 100, 100);
let newHTML = '';
// console.log('this is the cart total:',cartTotal)

// console.log('this is the user country for widget:',this.userCountry)

if (!['ROW'].includes(this.userCountry)) {
    if (cartTotal >= this.thresholdAmount) {
      newHTML = `
        <div class="cv-4-0-delivery-threshold">
          <p class="cv-4-0-free-delivery-title cv-4-0-bold">
            <span>🎉</span> Woohoo!
          </p>
          <p class="cv-4-0-threshold-msg">
            You’ve qualified for <span class="cv-4-0-bold">free delivery!</span>
          </p>
          <div class="cv-4-0-threshold-bar-container">
            <div class="cv-4-0-threshold-bar" style="width: 100%"></div>
          </div>
        </div>
      `;
    } else if (cartTotal > 0) {
      newHTML = `
        <div class="cv-4-0-delivery-threshold">
          <p class="cv-4-0-free-delivery-title cv-4-0-bold">
            <span>📦</span> Get free delivery!
          </p>
          <p class="cv-4-0-threshold-msg">
            You're only <span class="cv-4-0-bold cv-4-0-threshold-amount">${thresholdMessage}</span> away from <span class="cv-4-0-bold">free delivery!</span>
          </p>
          <div class="cv-4-0-threshold-bar-container">
            <div class="cv-4-0-threshold-bar" style="width: ${percentage}%"></div>
          </div>
        </div>
      `;
    }
  }

    if (thresholdElement) {
      thresholdElement.outerHTML = newHTML;
    } else {
      this.cartNotificationHeader.insertAdjacentHTML('afterend', newHTML);
    }
  }

  getCartTotal() {
    const cartTotalElement = document.querySelector('.totals__subtotal-value');
    if (cartTotalElement) {
      let cartTotalText = cartTotalElement.textContent.trim();

      // Replace comma with a decimal point
      cartTotalText = cartTotalText.replace(',', '.');

      return parseFloat(cartTotalText.replace(/[^\d.-]/g, ''));
      // return parseFloat(cartTotalElement.textContent.replace(/[^\d.-]/g, ''));
        }
    return 0;
  }
}



customElements.define('cart-notification', CartNotification);